// searchsync-current-refinements-component.js

import { getInstance, registerWidget } from './searchsync-create-instance';
import { currentRefinements } from 'instantsearch.js/es/widgets';

function initCurrentRefinementsWidget() {
  const tgblAlgoliaDataJSON = window.atob(tgblSearchsyncDataEncoded);
  const tgblAlgoliaData = jQuery.parseJSON(tgblAlgoliaDataJSON);

  const elements = document.querySelectorAll("[data-filter-type='currentRefinements']");
  const elementsArray = Array.from(elements);

  const elementsGroupedByIndex = elementsArray.reduce((acc, element) => {
    const dataIndexValue = element.getAttribute('data-index');
    if (!acc[dataIndexValue]) acc[dataIndexValue] = [];
    acc[dataIndexValue].push(element);
    return acc;
  }, {});

  for (const dataIndexValue in elementsGroupedByIndex) {
    if (!elementsGroupedByIndex.hasOwnProperty(dataIndexValue)) continue;

    const elementsWithSameIndex = elementsGroupedByIndex[dataIndexValue];
    const search = getInstance(dataIndexValue);

    elementsWithSameIndex.forEach((element) => {
      // widgetData (tgblAlgoliaData[data-id]) carries the label; currentRefinements needs no
      // per-attribute config, so the default InstantSearch rendering is used.
      const widget = currentRefinements({
        container: element,
      });

      search.addWidgets([widget]);
      registerWidget(element);
    });
  }
}

export { initCurrentRefinementsWidget };